var render = function render(_c,_vm){return _c('li',_vm._g(_vm._b({staticClass:"menu__item"},'li',_vm.data.attrs,false),_vm.listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }